import React, { Component, Fragment } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import SignIn from "./components/SignIn";
import SignUp from "./components/SignUp"; 
import requireAuth from "./components/requireAuth";
import NewCompany from "./components/tabs/NewCompany";
import ConcessionForm from './components/ConcessionForm';
import EditConcessionForm from './components/EditConcessionForm';
import Dashboard from "./components/tabs/Dashboard";
import HotspotsFileList from "./components/tabs/HotspotsFileList";
import NewUser from "./components/tabs/NewUser";
import ModisRecords from "./components/tabs/ModisRecords";
import ViirsRecords from "./components/tabs/ViirsRecords";
import TriggeredNotifications from "./components/tabs/TriggeredNotifications";
import ReportList from "./components/tabs/ReportList";
import ConfigureMap from "./components/tabs/ConfigureMap";
import EmailList from "./components/tabs/EmailList";
import PlantationList from "./components/tabs/PlantationList";
class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Fragment>
            <Route exact path="/" component={SignIn} />
            <Route exact path="/signIn" component={SignIn} />
            <Route exact path="/emaillist" component={requireAuth(EmailList)} />
            <Route exact path="/dashboard" component={requireAuth(Dashboard)} />
            <Route exact path="/form" component={ConcessionForm} />
            <Route exact path="/editform" component={requireAuth(EditConcessionForm)} />
            <Route exact path="/reportlist" component={requireAuth(ReportList)} />
            <Route exact path="/company" component={requireAuth(NewCompany)} />
            <Route exact path="/plantationlist" component={requireAuth(PlantationList)} />
            <Route exact path="/users" component={requireAuth(NewUser)} />
            <Route exact path="/rawmodis" component={requireAuth(ModisRecords)} />
            <Route exact path="/rawviirs" component={requireAuth(ViirsRecords)} />
            <Route exact path="/filtered" component={requireAuth(TriggeredNotifications)} />
            <Route exact path="/signUp" component={requireAuth(SignUp)} />
            <Route exact path="/hotspotsfile" component={requireAuth(HotspotsFileList)} />
            <Route exact path="/gotomap" component={requireAuth(ConfigureMap)} />
            
          
        </Fragment>
      </BrowserRouter>
    );
  }
}

export default App;
//  <Route exact path="/layers/request" component={requireAuth(UpdateLayerRequestList)} />
// <Route exact path="/layers/update" component={requireAuth(UpdateLayer)} />


/*
import Items from "./components/tabs/Items";
import UserList from "./components/tabs/UserList";
import UploadFile from "./components/UploadFile" 
import FileManageList from "./components/tabs/user/FileManageList"; 
import MainUserList from "./components/tabs/MainUserList";
import EmailUserList from "./components/tabs/EmailUserList";
import PlainUserList from "./components/tabs/PlainUserList";
            <Route exact path="/upload" component={requireAuth(UploadFile)} />
            <Route exact path="/users" component={requireAuth(UserList)} />
            <Route exact path="/files" component={requireAuth(FileManageList)} />
            <Route exact path="/users/main" component={requireAuth(MainUserList)} />
            <Route exact path="/users/email" component={requireAuth(EmailUserList)} />
            <Route exact path="/users/plain" component={requireAuth(PlainUserList)} />
            
            */


// WEBPACK FOOTER //
// ./src/App.js